module.exports = __webpack_public_path__ + "img/wcyg-money.ecd1db6e.svg";